module.exports = __webpack_public_path__ + "static/media/Soybean13R6.4705a6b4.PNG";